<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 19 18">
    <g clip-path="url(#clip0_6892_8962)">
      <path
        d="M2.16245 10.3846V15.6185L16.3963 1.38462H11.1624V0H18.7778V7.61539H17.3932V2.35385L3.13168 16.6154H8.39322V18H0.777832V10.3846H2.16245Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8962">
        <rect width="18" height="18" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
